import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  email
} from "admin-on-rest";
import {
  validateAdminDataEdit,
  validatePassword,
  validatePhone
} from "./validations";
import {formStyle} from "./style";

class AdminEditForm extends React.Component {
  render() {
    const props = {...this.props};
    return (
      <Edit title="resources.admins.titleEdit" {...props}>
        <SimpleForm validate={validateAdminDataEdit}>
          <TextInput
            label="resources.admins.inputs.email"
            source="email"
            type="email"
            validate={email}
          />

          <TextInput
            label="resources.admins.inputs.password"
            source="password"
            type="password"
            validate={validatePassword}
            style={formStyle.containerInput}
          />

          <TextInput
            label="resources.admins.inputs.repeatPassword"
            source="password2"
            type="password"
            validate={validatePassword}
          />

          <div style={formStyle.clearFloatContainer} />

          <TextInput
            label="resources.admins.inputs.phoneNumber"
            source="phone"
            validate={validatePhone}
          />
        </SimpleForm>
      </Edit>
    );
  }
}

export default AdminEditForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/Admins/AdminsEditForm.js